import AboutComponent from "./components/About/About";
import AttendanceComponent from "./components/Attendance/Attendance";
import Dashboard from "./components/Dashboard/Dashboard";
import Home from "./components/Home/Home";
import RatingWrapper from "./components/Rating/RatingWrapper";
import UserManagementWrapper from "./components/UserManagement/UserManagementWrapper";
import DataManagement from "./components/DataManagement/DataManagement";
import ZoomApp from "./components/Zoom/ZoomApp";
import { InsertChartOutlined, Group, HowToReg, StarBorder, Dataset, Analytics, LibraryBooks, VerifiedUserOutlined, Assignment, Work, VideoCall, AssessmentOutlined, Stadium, StadiumOutlined, AppRegistration, LinkedIn, Feedback } from '@mui/icons-material';
import ComingSoon from "./components/ComingSoon";
import AssignmentsIndex from "./components/Assigments/AssignmentsIndex";
import ResourceIndex from "./components/ResourceHub/ResourceIndex";
import AssessmentIndex from "./components/Assessments/AssessmentIndex";
import ActivityIndex from "./components/Activities/Index";
import MicroLearningPage from "./components/MicroLearning/MicroLearningPage";
import LinkedInFeed from "./components/About/LinkedInFeed";
import GrowthSessionManagementWrapper from "./components/GrowthSessions/GrowthSessionManagementWrapper";
import AnnualReviewIndex from "./components/Corporate/AnnualReview/AnnualReviewIndex";
import ProbationReviewIndex from "./components/Corporate/ProbationReview/ProbationReviewIndex";
import FormManagementIndex from "./components/Corporate/FormManagement/FormManagementIndex";
import EmployeeReviewsIndex from "./components/Corporate/Reviews/EmployeeReviewsIndex";
import ManagerReviewsTable from "./components/Corporate/FormManagement/ManagerReviewsTable";

// Check if corporate mode is enabled
const isCorporateMode = process.env.REACT_APP_CORPORATE_MODE === 'true';

const Routes = {
    mainRoutes: [
        {
            path: "/Home",
            name: "Home",
            component: Home,
            // icon: <AppRegistration />, // Removed to hide from sidebar
        },
        {
            // icon: DashboardLight,
        },
        // Annual Review - corporate mode only (hidden from sidebar but accessible via navigation)
        ...(isCorporateMode ? [{
            path: "/AnnualReview",
            name: "Annual Review",
            component: AnnualReviewIndex,
            role: "",
            status: "hidden",
            environment: "DEV, PROD, local",
        }] : []),
        // Reviews - corporate mode only (for employees only, shows table)
        ...(isCorporateMode ? [{
            path: "/Reviews",
            name: "Performance Reviews",
            component: EmployeeReviewsIndex,
            role: "Employee",
            status: "active",
            environment: "DEV, PROD, local",
            icon: <AssessmentOutlined />,
        }] : []),
        // Reviews - corporate mode only (shows team member reviews for managers)
        ...(isCorporateMode ? [{
            path: "/ManagerReviews",
            name: "Performance Reviews",
            component: ManagerReviewsTable,
            role: "Team Lead, Project Manager, Program Manager, HR",
            status: "active",
            environment: "DEV, PROD, local",
            icon: <AssessmentOutlined />,
        }] : []),
        // Probation Review - corporate mode only (keep for navigation)
        ...(isCorporateMode ? [{
            path: "/ProbationReview",
            name: "Probation Review",
            component: ProbationReviewIndex,
            role: "Employee, Team Lead, Project Manager, Program Manager, HR",
            status: "hidden", // Hidden from sidebar but accessible via navigation
            environment: "DEV, PROD, local",
        }] : []),
        // Review Management - corporate mode only (HR and Program Manager)
        ...(isCorporateMode ? [{
            path: "/FormManagement",
            name: "Performance Review Management",
            component: FormManagementIndex,
            role: "",
            status: "active",
            environment: "DEV, PROD, local",
            icon: <Assignment />,
        }] : []),
        // Dashboard - hidden in corporate mode
        ...(!isCorporateMode ? [{
            path: '/Dashboard',
            name: "Dashboard",
            component: Dashboard,
            role: "Mentor,Client, Lead",
            status: "active",
            environment: "DEV, PROD, local",
            icon: <InsertChartOutlined />,
        }] : []),
        // Assessments - hidden in corporate mode
        ...(!isCorporateMode ? [{
            path: "/AssessmentIndex",
            name: "Assessments",
            role: "Mentor,User",
            status: "active",
            environment: "DEV, PROD, local",
            component: AssessmentIndex,
            icon: <AssessmentOutlined />,
        }] : []),
        // User Management - HR and Program Manager only
        {
            path: "/UserManagement",
            name: "User Management",
            role: "",
            status: "active",
            environment: "DEV, PROD, local",
            component: UserManagementWrapper,
            icon: <Group />,
        },
        // Data Management - hidden in corporate mode
        ...(!isCorporateMode ? [{
            path: "/DataManagement",
            name: "Data Management",
            status: "active",
            role: "Mentor",
            environment: "DEV, PROD, local",
            component: DataManagement,
            icon: <Dataset />,
        }] : []),
        
        // LinkedIn Feed - hidden in corporate mode
        ...(!isCorporateMode ? [{
            path: '/LinkedInFeed',
            name: "LinkedIn Feed",
            status: "inactive-prod",
            role: "Mentor, User",
            environment: "DEV",
            component: LinkedInFeed,
            icon: <LinkedIn />,
        }] : []),
        // Attendance - hidden in corporate mode
        ...(!isCorporateMode ? [{
            path: "/Attendance",
            name: "Minute Minder",
            status: "inactive-prod",
            role: "Mentor, User",
            component: AttendanceComponent,
            environment: "DEV, PROD, local",
            icon: <HowToReg />,
        }] : []),
        // Growth Conversations - corporate mode only, shown but disabled
        ...(isCorporateMode ? [{
            path: "/FeedbackManagement",
            name: "Growth Conversations",
            component: GrowthSessionManagementWrapper,
            role: "Employee, Team Lead, Project Manager, Program Manager, HR",
            status: "disabled",
            environment: "DEV, PROD, local",
            icon: <Feedback />,
        }] : []),
        // Self-Reflect & Rise - corporate mode only, shown but disabled
        ...(isCorporateMode ? [{
            path: "/Rating",
            name: "Self-Reflect & Rise",
            component: RatingWrapper,
            role: "Employee, Team Lead, Project Manager, Program Manager, HR",
            status: "disabled",
            environment: "DEV, PROD, local",
            icon: <StarBorder />,
        }] : []),
        // {
        //     path: "/About",
        //     name: "About",
        //     component: AboutComponent,
        //     // icon: DashboardLight,
        // },
        // {
        //     path: "/Index",
        //     name: "Team Activities",
        //     component: ActivityIndex,
        //     icon: <StadiumOutlined />,
        // },
        // {
        //     path: "/MicroLearningPage",
        //     name: "Micro Learning",
        //     component: MicroLearningPage,
        //     icon: <Dataset />,
        // },
        
        // {
        //     path: "/ZoomApp",
        //     name: "Meeting",
        //     component: ZoomApp,
        //     icon: <VideoCall />,
        // },
        // {
        //     path: "/AssignmentsIndex",
        //     name: "Work Assignments",
        //     component: AssignmentsIndex,
        //     icon: <Assignment />,
        // },

        // {
        //     path: "/ComingSoon",
        //     name: "Growth & Progress",
        //     component: ComingSoon,
        //     icon: <Analytics />,
        // },
        // {
        //     path: "/ResourceIndex",
        //     name: "Resource Hub",
        //     component: ResourceIndex,
        //     icon: <LibraryBooks />,
        // },
        // {
        //     path: "/ComingSoon",
        //     name: "Career Profiles",
        //     component: ComingSoon,
        //     icon: <VerifiedUserOutlined />,
        // },
        // {
        //     path: "/ComingSoon",
        //     name: "Performance Trials",
        //     component: ComingSoon,
        //     icon: <Work />,
        // }
    ]
}

export default Routes;